import { formatCrawlTime, toBadges } from '@components/SitemapReport/utils'
import type { PagesDto } from '@octopus-do/octopus-api-client'
import type React from 'react'

import { PageRow } from './components'

interface Props {
  items: PagesDto['items']
}

export const PagesList: React.FC<Props> = ({ items }) => (
  <>
    {items.map((page) => (
      <PageRow
        key={page.url}
        url={page.url}
        status={page.status ?? null}
        title={page.title?.trim() || null}
        h1={page.h1?.trim() || null}
        // An API from before OCT-5439 sends no date at all.
        changedAt={formatCrawlTime(page.changedAt ?? null)}
        badges={toBadges(page.badges, page.status)}
      />
    ))}
  </>
)
